import angular from 'angular';

import CollaboratorManageModalComponent from './collaborator-manage-modal.cmpt';

export default angular
    .module('application.component.modals.component.collaborator-manage-modal', [])
    .component(CollaboratorManageModalComponent.selector, CollaboratorManageModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/collaborator-manage-modal/index.js